import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { findLink } from '../../../../../LinkyLinky';
import { UserProductLicenseResource } from '../../../../../ParticipantsStore/Types';

interface Props {
  license: UserProductLicenseResource;
}

function LicenseDetails({ license }: Props) {
  return (
    <span className="w-6">
      {findLink('logo-on-white', license.links)
        .map(({ href }) => <img aria-hidden width={24} src={href} alt="logo" />)
        .getOrElse(emptyFragment)}
    </span>
  );
}

export default observer(LicenseDetails);
